import React from 'react'

function EcommerceSolutions() {
  return (
    <div>EcommerceSolutions</div>
  )
}

export default EcommerceSolutions